export function formatChainFree(chainFree: string | string[]) {
    if (chainFree === 'true') {
        return 'Chain free';
    }

    return '';
}
